
if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');

  // Barbarana: faixas de CEP -> UF (Correios) usadas para preencher o estado
  // automaticamente, ja que os campos Pais/Estado ficam ocultos no carrinho.
  const BR_ZIP_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
    [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
    [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
    [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
    [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
    [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
    [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'],
    [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'],
    [90000, 99999, 'RS']
  ];

  const BR_PROVINCE_NAMES = {
    AC: ['Acre'], AL: ['Alagoas'], AP: ['Amapa'], AM: ['Amazonas'],
    BA: ['Bahia'], CE: ['Ceara'], DF: ['Distrito Federal', 'Federal District'],
    ES: ['Espirito Santo'], GO: ['Goias'], MA: ['Maranhao'],
    MT: ['Mato Grosso'], MS: ['Mato Grosso do Sul'], MG: ['Minas Gerais'],
    PA: ['Para'], PB: ['Paraiba'], PR: ['Parana'], PE: ['Pernambuco'],
    PI: ['Piaui'], RJ: ['Rio de Janeiro'], RN: ['Rio Grande do Norte'],
    RS: ['Rio Grande do Sul'], RO: ['Rondonia'], RR: ['Roraima'],
    SC: ['Santa Catarina'], SP: ['Sao Paulo'], SE: ['Sergipe'],
    TO: ['Tocantins']
  };

  const normalizeName = (value) =>
    (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xEstimateShipping", (el, single, multiple, noRates) => ({
        countryEl: el.querySelector('.country-select'),
        provinceEl: el.querySelector('.province-select'),
        provinceContainer: el.querySelector('.province-container'),
        zip: el.querySelector('.zip-input'),
        rates: el.querySelector('.rates'),
        errors: el.querySelector('.errors'),
        loadingShipping: false,
        rates_heading: '',
        rates_text: '',
        errors_message: '',
        cachedData: [],
        cachedResponse:[],
        load() {
          this.setSelectedOption(this.countryEl, this.countryEl.dataset.default);
    
          if (this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
            this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
          }
    
          this.handleCountryChange();
          this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
        },
        
        handleCountryChange() {
          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces);
    
          Array.from(this.provinceEl.options).forEach((option) => option.remove());
    
          if (provinces && provinces.length === 0) {
            this.provinceContainer.hidden = true;
          } else {
            provinces.forEach((province) => {
              const option = document.createElement('option');
              [option.value, option.innerHTML] = province;
              this.provinceEl.appendChild(option);
            });
    
            this.provinceContainer.hidden = false;
          }
        },

        setSelectedOption(selector, value) {
          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.innerHTML === value) {
              selector.selectedIndex = index;
            }
          });
        },

        // Barbarana: descobre a UF a partir do CEP digitado
        brProvinceFromZip(zipValue) {
          const digits = (zipValue || '').toString().replace(/\D/g, '');
          if (digits.length < 5) return null;
          const prefix = parseInt(digits.slice(0, 5), 10);
          if (isNaN(prefix)) return null;
          const range = BR_ZIP_RANGES.find(([min, max]) => prefix >= min && prefix <= max);
          return range ? range[2] : null;
        },

        // Barbarana: como o select de estado esta oculto, sincronizamos ele com o CEP
        // antes de consultar as taxas, para nao cotar frete para o estado errado.
        syncProvinceFromZip() {
          if (!this.countryEl || !this.provinceEl || !this.zip) return;
          if (!normalizeName(this.countryEl.value).startsWith('bra')) return;
          if (this.provinceEl.options.length === 0) return;

          const uf = this.brProvinceFromZip(this.zip.value);
          if (!uf) return;

          const targets = [uf.toLowerCase()].concat((BR_PROVINCE_NAMES[uf] || []).map(normalizeName));
          const match = Array.from(this.provinceEl.options).find((option) =>
            targets.includes(normalizeName(option.value)) ||
            targets.includes(normalizeName(option.textContent))
          );

          if (match) this.provinceEl.value = match.value;
        },

        async submit(e) {
          
          e?.preventDefault();

          this.syncProvinceFromZip();
    
          this.errors.classList.add('hidden');
          this.rates.classList.add('hidden');
          
          const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.countryEl.value}&shipping_address[province]=${this.provinceEl.value}`;
    
          if (this.cachedData[params]) {
            if ( this.cachedResponse[params]) {
              this.showRates(this.cachedData[params]);
            } else {
              this.showErrors(this.cachedData[params]);
            }
            return true;
          }

          this.loadingShipping = true;
          try {
            const response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
            const data = await response.json();
    
            if (response.ok) {
              this.showRates(data);
            } else {
              this.showErrors(data);
            }
            this.cachedResponse[params] = response.ok;
            this.cachedData[params] = data;
          } catch (error) {
            console.log(error); 
          } finally {
            this.loadingShipping= false;
          }
        },
    
        showRates(data) {
          const headingEl = this.rates.querySelector('.rates-heading');
    
          if (data.shipping_rates && data.shipping_rates.length) {
            this.rates_heading = data.shipping_rates.length === 1 ? single : multiple;
            let rates = '';
            
            data.shipping_rates.forEach((rate) => {
              const formattedRate = rate.price + rate.currency;
              rates += `<li class="pt-2">${rate.name}: ${formattedRate}</li>`;
            });
    
            headingEl.classList.remove('hidden');
            this.rates_text = `<ul class="list-disc pl-4">${rates}</ul>`;
          } else {
            headingEl.classList.add('hidden');
            this.rates_text = `<p class="no-rate">${noRates}</p>`;
          }
    
          this.rates.classList.remove('hidden');
        },
    
        showErrors(data) {
          let errors = '';
          Object.keys(data).forEach((key) => {
            errors += `<li>${data[key]}</li>`;
          });
    
          this.errors_message = `<ul>${errors}</ul>`;
          this.errors.classList.remove('hidden');
        }
      }));
      Alpine.store('xPopupShipping', {
        open: false
      });
    });
  });
}